import { Icon, Text, HStack, VStack } from '@genial/components';
import React, { useState } from 'react';
import { Pressable } from 'react-native';

import { chartTypeTabsInitialTab, chartTabsList } from './constants';

namespace ChartTypeTabsTypes {
  export type ChartTypeTabsProps = {
    onSelectChartType?: (chartType: string) => void;
  };
}

export const ChartTypeTabs: React.FC<ChartTypeTabsTypes.ChartTypeTabsProps> = ({
  onSelectChartType,
}) => {
  const [selectedTab, setSelectedTab] = useState(chartTypeTabsInitialTab);

  const handleTabChange = (tab: string) => {
    onSelectChartType?.(tab);
    setSelectedTab(tab);
  };

  const tabItems = chartTabsList.map((tab) => {
    const isSelected = selectedTab === tab.key;
    return (
      <Pressable onPress={() => handleTabChange(tab.key)} key={tab.key}>
        <VStack alignItems="center" space="stack.quarck">
          <Icon name={tab.icon} size="xs" color={isSelected ? 'neutral.black' : 'neutral.medium'} />
          <Text
            variant={isSelected ? 'bold' : 'regular'}
            color={isSelected ? 'neutral.black' : 'neutral.medium'}>
            {tab.label}
          </Text>
        </VStack>
      </Pressable>
    );
  });

  return (
    <HStack width="full" justifyContent="space-between" space="stack.xxxs">
      {tabItems}
    </HStack>
  );
};
